// AT-2102 | AT-2161 | Ankur Makavana | 18-07-2023 | Reports to have to 2 sub-sections: 1. Mobile Reports Desktop 2. MIS Reports Reports Master - to be greyed out for now Finance Reports - to be greyed out for now Business Reports
import React from "react";
import customFetch from "./apicall/api";
import { logout, generateId } from "./Utility";
import { ThemeContext } from "../context/IsLoader";
import Mobile_report from "./Mobile_report";
import PBI_report from "./PBI_report";
import { PEDiv } from "./permissionComponents";
import ReportHeader from "./Report_header";
import { Redirect } from "react-router-dom";

const generate_Id1 = generateId(10);
class Report_categories extends React.Component {
  static contextType = ThemeContext;
  constructor(props) {
    super(props);
    this.state = {
      sub_categories_data: [],
      isSpin: false,
      flag: 0,
      dataLoaded: false,
    };
  }
  componentDidMount() {
    // Inject responsive body padding style only for this component
    this.reportBodyStyle = document.createElement('style');
    this.reportBodyStyle.setAttribute('data-report-body-padding', 'true');
    this.reportBodyStyle.innerHTML = `@media (max-width: 768px) { body { padding: 0 !important; } }`;
    document.head.appendChild(this.reportBodyStyle);

    if (
      window.Android &&
      typeof window.Android.getDataFromLocalStorage === "function"
    ) {
      const data = window.Android.getDataFromLocalStorage("your_key");
      document.head.appendChild(this.reportBodyStyle);
      if (data) {
        this.setState({ isSpin: false, flag: 1 }); // Set flag to 1 if accessed from Android
        const tokenParts = data.split(",");
        const tokenData = {};

        tokenParts.forEach((part) => {
          const [key, value] = part.split(":");
          tokenData[key] = value;
        });

        console.log("AndroidInterface->", data);
      }
    } else {
      console.log(
        "Error in AndroidInterface: Android method not found or not available."
      );
    }


    setTimeout(() => {
      if (document.readyState === "complete") {
        this.context.onPageLoad({
          component: this.constructor.name,
          component_id: generate_Id1,
        });
      } else {
        window.addEventListener("load", this.context.onPageLoad());
        this.cleanup = () =>
          window.removeEventListener("load", this.context.onPageLoad());
      }
    }, 1000);
    const { api_token, categories_id, sub_categories } =
      (this.props.location && this.props.location.state) || {};

    const sort_data = [];

    for (let i = 0; i < sub_categories.length; i++) {
      if (sub_categories[i].report_category_id == categories_id) {
        sort_data.push(sub_categories[i]);
      }
    }

    this.setState({
      sub_categories_data: sort_data,
      dataLoaded: true,
    });

  }

  componentWillUnmount() {
    // Remove the injected style tag
    if (this.reportBodyStyle && this.reportBodyStyle.parentNode) {
      this.reportBodyStyle.parentNode.removeChild(this.reportBodyStyle);
    }
  }
  
  render() {
    const {
      api_token,
      categories_name,
      categories_id,
      effective_designation_id,
      hideHeader,
      affinity_list,
    } = (this.props.location && this.props.location.state) || {};
    const { sub_categories_data, dataLoaded } = this.state;
    return (
      !dataLoaded ? (<></>) :
      <>
        {this.state.isSpin ? (
          <div className="preloader">
            <div className="loader" ng-hide="data.length > 0"></div>
          </div>
        ) : (
          ""
        )}
        <div className="container no-container" id="reportCategories">
          {/* <div className="container no-container"> */}

          {hideHeader && <ReportHeader
            title={categories_name}
            showBack={sub_categories_data.length > 0 || this.state.flag === 1}
            onBack={() => this.props.history.goBack()}
            onHome={() =>
              this.props.history.push({
                pathname: "/dashboard",
                state: { api_token },
              })
            }
            showLogout={this.state.flag === 0}
          />}

          <div className="dashboard-card-holder row mt-4">
            {categories_id == 3 ? (
              <PBI_report
                api_token={api_token}
                categories_id={categories_id}
                effective_designation_id={effective_designation_id}
                props={this.props}
              />
            ) : sub_categories_data.length > 0 ? (
              sub_categories_data.map((categories, index) => (
                categories.report_category_id == 4 ? (
                  <>
                    <div className="image-report-2">
                      <div
                        className={
                          categories.status != "A" || !categories.is_accessible
                            ? "not-allowed m-2"
                            : "m-2"
                        }
                        onClick={() => {
                          this.props.history.push({
                            pathname: "/BIReports",
                            state: {
                              api_token: api_token,
                              subcategories_id: categories.report_subcategory_id,
                              subcategories_name: categories.subcategory_name,
                              report_category_id: categories.report_category_id,
                              hideHeader: hideHeader,
                              affinity_list: affinity_list,
                            },
                          });
                        }}
                      >
                        {categories.ui_img_path ? (
                          <img
                            src={require("../assets/images/" +
                              categories.ui_img_path)}
                            alt=""
                          />
                        ) : (
                          <img
                            src={require("../assets/images/check-list.png")}
                            alt=""
                          />
                        )}
                        <h5>{categories.subcategory_name}</h5>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="image-report-2">
                      <div
                        className={
                          categories.status != "A" || !categories.is_accessible
                            ? "not-allowed m-2"
                            : "m-2"
                        }
                        onClick={() => {
                          this.props.history.push({
                            pathname: "/Report_list",
                            state: {
                              api_token: api_token,
                              subcategories_id: categories.report_subcategory_id,
                              subcategories_name: categories.subcategory_name,
                              report_category_id: categories.report_category_id,
                              hideHeader: hideHeader
                            },
                          });
                        }}
                      >
                        {categories.ui_img_path ? (
                          <img
                            src={require("../assets/images/" +
                              categories.ui_img_path)}
                            alt=""
                          />
                        ) : (
                          <img
                            src={require("../assets/images/check-list.png")}
                            alt=""
                          />
                        )}
                        <h5>{categories.subcategory_name}</h5>
                      </div>
                    </div>
                  </>
                )
              ))
            ) : (categories_id == 4 && !sub_categories_data.some((categories) => categories.report_category_id == 4)) ? (
              <Redirect
                to={{
                  pathname: "/BIReports",
                  state: {
                    api_token: api_token,
                    // subcategories_id: categories_id,
                    subcategories_name: categories_name,
                    report_category_id: categories_id,
                    hideHeader: hideHeader,
                    affinity_list: affinity_list,
                  },
                }}
              />
              // <SupersetDashboard
              //   api_token={api_token}
              //   categories_id={categories_id}
              //   effective_designation_id={effective_designation_id}
              //   props={this.props}
              // />
            ) : (
              // <div className="text-center">No Data Found</div>
              <Mobile_report
                api_token={api_token}
                categories_id={categories_id}
                effective_designation_id={effective_designation_id}
                props={this.props}
              />
            )}
          </div>
        </div>
      </>
    );
  }
}
export default Report_categories;
